import { isNotDefined } from './core.js';

function listToMap(list, keySelector, modifier) {
  if (isNotDefined(list)) {
    return undefined;
  }

  const value = list.reduce((acc, elem, i) => {
    const key = keySelector(elem, i);
    acc[key] = modifier ? modifier(elem, key, i, acc) : elem;
    return acc;
  }, {});
  return value;
}
/**
 * Transform object to list
 * @param obj
 * @param modifier get new value from item in object
 */

function mapToList(obj, modifier) {
  if (isNotDefined(obj)) {
    return undefined;
  }

  return Object.keys(obj).reduce((acc, key, i) => {
    const elem = obj[key];
    acc.push(modifier ? modifier(elem, key, i, acc) : elem);
    return acc;
  }, []);
}
/**
 * Transform object to object
 * @param obj
 * @param keySelector get new key for item in object
 * @param modifier get new value for item in object
 */

function mapToMap(obj, keySelector, modifier) {
  if (isNotDefined(obj)) {
    return undefined;
  }

  const value = Object.keys(obj).reduce((acc, k, i) => {
    const elem = obj[k];
    const key = keySelector ? keySelector(k, elem) : k;
    acc[key] = modifier ? modifier(elem, k, i, acc) : elem;
    return acc;
  }, {});
  return value;
}
/**
 * Group list into object of list.
 * Items in list are grouped by key returned by keySelector
 * @param list
 * @param keySelector get key for item in list
 * @param modifier get new value for item in list
 */

function listToGroupList(list, keySelector, modifier) {
  if (isNotDefined(list)) {
    return undefined;
  }

  const val = list.reduce((acc, elem, i) => {
    const key = keySelector(elem, i);
    const value = modifier ? modifier(elem, key, i, acc) : elem;
    const group = acc[key];

    if (group) {
      group.push(value);
    } else {
      acc[key] = [value];
    }

    return acc;
  }, {});
  return val;
}

export { listToGroupList, listToMap, mapToList, mapToMap };
//# sourceMappingURL=transform.js.map
